import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/ReceiverLanding';

const ReceiverLandingPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default ReceiverLandingPage;
